'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className="nav-landing" style={{ boxShadow: scrolled ? '0 4px 24px rgba(0,0,0,0.4)' : 'none' }}>
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 w-full flex items-center justify-between">
        <Link href="/" className="flex items-center gap-3">
          <AppLogo size={36} />
          <span className="font-bold text-lg text-foreground hidden sm:block">Brain Basket</span>
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-6">
          {[
            { label: 'How It Works', href: '#how-it-works' },
            { label: 'Categories', href: '#categories' },
            { label: 'Professions', href: '#professions' },
            { label: 'Leaderboard', href: '/user-dashboard' },
          ]?.map((item) => (
            <Link key={`lnav-${item?.label}`} href={item?.href}
              className="text-sm font-medium transition-colors hover:text-foreground"
              style={{ color: 'var(--muted-foreground)' }}>
              {item?.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <Link href="/sign-up-login-screen" className="btn-ghost text-sm py-2 px-4 hidden sm:flex">
            Sign In
          </Link>
          <Link href="/sign-up-login-screen" className="btn-primary text-sm py-2 px-4">
            Start Free
          </Link>
          <button
            className="md:hidden p-2 rounded-lg transition-colors hover:bg-muted"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle mobile menu"
          >
            {mobileOpen ? <X size={20} style={{ color: 'var(--foreground)' }} /> : <Menu size={20} style={{ color: 'var(--foreground)' }} />}
          </button>
        </div>
      </div>
      {/* Mobile menu */}
      {mobileOpen && (
        <div className="absolute top-16 left-0 right-0 md:hidden z-50 py-4 px-4"
          style={{ background: 'rgba(13, 20, 36, 0.98)', borderBottom: '1px solid var(--border)' }}>
          {['How It Works', 'Categories', 'Professions', 'Leaderboard']?.map((item) => (
            <div key={`mob-lnav-${item}`} className="py-3 border-b" style={{ borderColor: 'var(--border)' }}>
              <span className="text-sm font-medium" style={{ color: 'var(--foreground)' }}>{item}</span>
            </div>
          ))}
          <div className="pt-4 flex gap-3">
            <Link href="/sign-up-login-screen" className="btn-ghost flex-1 justify-center py-2">Sign In</Link>
            <Link href="/sign-up-login-screen" className="btn-primary flex-1 justify-center py-2">Start Free</Link>
          </div>
        </div>
      )}
    </nav>
  );
}